
// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import Activities from "./components/Activities";
import Attractions from "./components/Attractions";
// import Pricing from "./components/Pricing";
// import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import "./App.css";

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      mirror: true,
    });
  }, []);

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={
          <>
            <HeroSection />
            <Activities />
            <Attractions />
            {/* <Gallery /> */}
            {/* <Pricing /> */}
            <Contact />
          </>
        } />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;